export default "__VITE_ASSET__uo8VntfI__"